import { QuotationStatus } from '@/constants/quotation'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { quotationApi } from '../api/quotationApi'
import type { Quotation } from '../types/quotation'

// export function useGetQuotations(productId: string, enabled = true) {
//   return useQuery({
//     queryKey: ['quotaion'],
//     queryFn: () => quotationApi.getQuotations(productId),
//     retry: false,
//     refetchOnWindowFocus: false,
//     enabled: enabled && !!productId,
//   })
// }

export function useGetQuotations(
  params?: { vendorId?: string; productId?: string; status?: QuotationStatus },
  enabled = true,
) {
  return useQuery({
    queryKey: ['quotaions', params],
    queryFn: () => quotationApi.getQuotations(params),
    retry: false,
    refetchOnWindowFocus: false,
    enabled,
  })
}

export function useGetQuotation(id: string, enabled = true) {
  return useQuery({
    queryKey: ['quotaion', id],
    queryFn: () => quotationApi.getQuotation(id),
    enabled: enabled && !!id,
  })
}

export function useCreateQuotation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ payload }: { payload: Partial<Quotation> }) => quotationApi.createQuotation(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['quotaions'] })
    },
  })
}

export function useUpdateQuotation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id, payload }: { id: string; payload: Partial<Quotation> }) =>
      quotationApi.updateQuotation(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['quotaion'] })
    },
  })
}
